var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Alias Separation" },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [
                _vm._v(
                  "\n        Remove Alias " +
                    _vm._s(_vm.aliasName) +
                    "?\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", [
            _vm._v("\n      The alias "),
            _c("strong", [_vm._v(_vm._s(_vm.aliasName))]),
            _vm._v(" will be removed from this data source.\n    "),
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("delete_forever"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    outline: "",
                    color: "secondary",
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Button.Cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }